import ButtonSimple from './ButtonSimple';

export default class ButtonHome extends ButtonSimple {
  constructor({ game, x = 0, y = 0, up, over, atlas = 'ui_buttons', pressed, sfxID }) {
    super({ game, x, y, up, over, atlas, sfxID });
    this.frameNormal = up;
    this.framePressed = pressed;

    this.anchor.set(0.5);

    this.onPressed = new Phaser.Signal();

    this.state = 1;

    //
    if (this.game.deviceMetric.platform.type === 'smartphone') {
      this.scale.set(1.2);
    }
  }

  onDown() {
    super.onDown();

    if (this.state === 1) {
      this.setStatePressed();
    } else {
      this.onPressed.dispatch();
    }
  }

  setStatePressed() {
    this.state = 2;
    const frame = this.framePressed;
    this.setFrames(frame, frame, frame, frame);

    this.game.time.events.add(3000, this.setStateNormal, this);
  }

  setStateNormal() {
    this.state = 1;
    const frame = this.frameNormal;
    this.setFrames(frame, frame, frame, frame);
  }
}
